<template>
    <p class="input__box">
        <input type="checkbox" :id="props.id" :checked="props.checked" @change="onChanged" class="check__input" />
        <label :for="props.id" class="check__label">{{ props.label }}</label>
        <!-- <input type="checkbox" :id="fileldLabel" :checked="checked" @change="onChanged" class="check__input"  />
        <label :for="fileldLabel" class="check__label">{{ fileldLabel }}</label> -->

        <!-- <input type="checkbox" :id="props.id" :checked="props.checked" @change="onChanged" class="check__input" />
        <label :for="props.id" class="check__label"> {{ props.label }}</label> -->

        <!-- <input type="checkbox" id="all" class="check__input" />
        <label for="all" class="check__label">전체</label>
        <input type="checkbox" id="disabled" class="check__input" disabled />
        <label for="disabled" class="check__label">전체</label> -->
    </p>
</template>

<script setup>
import { onMounted, ref, computed, watch, defineEmits } from 'vue';

// const one = ref(props.obj);
// const fileldLabel = ref(props.label);
// const checked = ref(props.checked);

// const chId = computed(() => {
//     return props.obj.label;
// });
// const chChecked = computed(() => {
//     return props.obj.checked;
// });
// const chLabel = computed(() => {
//     return props.obj.label;
// });
const props = defineProps({
    // obj: {
    //     type: Object,
    //     default: { idx: 0, checked: false, value: '1', label: '모든 레벨test' },
    //     required: true,
    // },
    id: {
        type: String,
        default: 'test',
        required: true,
    },
    label: {
        type: String,
        default: 'test',
        required: true,
    },
    checked: {
        type: Boolean,
        default: false,
        required: true,
    },
});
const emit = defineEmits(['onReturn', 'update:checked']);

const isChecked = ref(props.checked);

const onChanged = (event) => {
    // console.log(' checkbox onChanged : start', event.target.checked);
    emit('onReturn', event.target.checked);
    emit('update:checked', event.target.checked);
};
// onMounted(() => {});
</script>

<style scoped lang="scss">
// .Normal {
//     background-color: antiquewhite;
// }

// .Checked {
//     background-color: aqua;
// }
</style>
